<template>
    <div @click="$modal.show('video-modal')" class="video-section">
        <img src="/images/stream-dreams/backgrounds/fuslie.jpg" alt="Fuslie">
    </div>
</template>

<script>
export default {
    name: 'VideoSection',
}
</script>

<style lang="scss" scoped>
    .video-section {
        max-height: 650px;
        display: flex;
        justify-content: center;
        align-items: center;
        overflow: hidden;
        cursor: pointer;

        @media(min-width: 1921px) {
            max-height: 800px;
        }

        img {
            width: 100%;
        }
    }
</style>
